import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon
} from "@heroicons/react/24/outline";
import { FC, ReactNode } from "react";
import { IEsimDiagnosticsHint } from "../../../interfaces/esim/EsimDiagnostics.types";

const severityStyle = (
  severity: string
): { wrap: string; icon: ReactNode } => {
  switch (severity) {
    case "Critical":
      return {
        wrap: "border-l-4 border-red bg-red/5",
        icon: <XCircleIcon className="w-5 h-5 text-red shrink-0" />
      };
    case "Warning":
      return {
        wrap: "border-l-4 border-orange bg-orange/5",
        icon: <ExclamationTriangleIcon className="w-5 h-5 text-orange shrink-0" />
      };
    default:
      return {
        wrap: "border-l-4 border-blue bg-blue/5",
        icon: <InformationCircleIcon className="w-5 h-5 text-blue shrink-0" />
      };
  }
};

const ProblemFixCallout: FC<{ hints: IEsimDiagnosticsHint[] }> = ({ hints }) => {
  if (!hints?.length) return null;

  return (
    <div className="flex flex-col gap-2">
      {hints.map((hint, index) => {
        const style = severityStyle(hint.severity);
        return (
          <div
            key={`${hint.problem}-${index}`}
            className={`flex items-start gap-3 rounded-lg p-3 ${style.wrap}`}
          >
            {style.icon}
            <div className="text-sm">
              <p className="font-semibold text-gray-900">{hint.problem}</p>
              {hint.suggestedFix && (
                <p className="mt-0.5 text-gray-700">{hint.suggestedFix}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProblemFixCallout;
